import { IParametreSetiGrubu, IParametreSeti } from '../../../interfaces/IParametreSeti.interface';
import { IParametre } from '../../../interfaces/IParametre/IParametre';

// =============================================
// 1. FİRMA YÖNETİMİ
// =============================================
const FIRMA_KAYIT: IParametreSeti = {
  id: 'firma.kayit',
  baslik: 'Firma Kayıt',
  simge: '🏢',
  aciklama: 'Yeni firma kaydı oluşturma',
  sayfaKurallari: { yeniSayfaEngelle: true, maxSayfa: 1 },
  parametreler: [
    { ismi: 'firma_adi', baslik: 'Firma Adı', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'vergi_no', baslik: 'Vergi No', turu: 'Yazı' },
    { ismi: 'vergi_dairesi', baslik: 'Vergi Dairesi', turu: 'Yazı' },
    { ismi: 'sektor', baslik: 'Sektör', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Üretim', 'Yazılım', 'Hizmet', 'Ticaret', 'Diğer'] } },
    { ismi: 'telefon', baslik: 'Telefon', turu: 'Yazı' },
    { ismi: 'email', baslik: 'E-posta', turu: 'Yazı' },
    { ismi: 'adres', baslik: 'Adres', turu: 'Yazı Alanı' },
    { ismi: 'konum', baslik: 'Konum', turu: 'Konum' },
    { ismi: 'web_sitesi', baslik: 'Web Sitesi', turu: 'Yazı' },
    { ismi: 'logo', baslik: 'Logo', turu: 'Resim' },
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Aktif', 'Pasif', 'Beklemede'] }, degeri: 'Aktif' },
    { ismi: 'notlar', baslik: 'Notlar', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const FIRMA_DEPARTMAN: IParametreSeti = {
  id: 'firma.departman',
  baslik: 'Departman',
  simge: '🏛️',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'departman_adi', baslik: 'Departman Adı', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'yonetici', baslik: 'Yönetici', turu: 'Yazı' },
    { ismi: 'aciklama', baslik: 'Açıklama', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const FIRMA_YETKI: IParametreSeti = {
  id: 'firma.yetki',
  baslik: 'Yetki Tanımı',
  simge: '🔑',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'yetki_adi', baslik: 'Yetki Adı', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'aciklama', baslik: 'Açıklama', turu: 'Yazı Alanı' },
    { ismi: 'seviye', baslik: 'Seviye', turu: 'Sayı', degeri: 0 },
  ] as IParametre[],
};

const FIRMA_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.firmalar',
  baslik: 'Firma Yönetimi',
  simge: '🏢',
  renk: '#1890ff',
  kaynak: 'kod',
  sira: 1,
  altGruplar: [FIRMA_KAYIT, FIRMA_DEPARTMAN, FIRMA_YETKI],
};

// =============================================
// 2. PERSONEL YÖNETİMİ
// =============================================
const PERSONEL_KAYIT: IParametreSeti = {
  id: 'personel.kayit',
  baslik: 'Personel Kayıt',
  simge: '👤',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'ad', baslik: 'Ad', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'soyad', baslik: 'Soyad', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'tc_no', baslik: 'TC Kimlik No', turu: 'Yazı' },
    { ismi: 'telefon', baslik: 'Telefon', turu: 'Yazı' },
    { ismi: 'email', baslik: 'E-posta', turu: 'Yazı' },
    { ismi: 'departman', baslik: 'Departman', turu: 'Açılır Kutu', ayarlar: { secenekler: [] } },
    { ismi: 'pozisyon', baslik: 'Pozisyon', turu: 'Yazı' },
    { ismi: 'giris_tarihi', baslik: 'İşe Giriş Tarihi', turu: 'Tarih' },
    { ismi: 'maas', baslik: 'Maaş', turu: 'Para' },
    { ismi: 'profil_resmi', baslik: 'Profil Resmi', turu: 'Resim' },
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Aktif', 'Pasif', 'İzinli', 'Ayrılmış'] }, degeri: 'Aktif' },
  ] as IParametre[],
};

const IZIN_KAYIT: IParametreSeti = {
  id: 'personel.izin',
  baslik: 'İzin Kaydı',
  simge: '🏖️',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'izin_turu', baslik: 'İzin Türü', turu: 'Açılır Kutu', ayarlar: { zorunlu: true, secenekler: ['Yıllık', 'Hastalık', 'Mazeret', 'Doğum', 'Evlilik', 'Ölüm', 'Ücretsiz'] } },
    { ismi: 'baslangic', baslik: 'Başlangıç', turu: 'Tarih', ayarlar: { zorunlu: true } },
    { ismi: 'bitis', baslik: 'Bitiş', turu: 'Tarih', ayarlar: { zorunlu: true } },
    { ismi: 'gun_sayisi', baslik: 'Gün Sayısı', turu: 'Sayı' },
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Beklemede', 'Onaylandı', 'Reddedildi'] }, degeri: 'Beklemede' },
    { ismi: 'onaylayan', baslik: 'Onaylayan', turu: 'Yazı' },
    { ismi: 'aciklama', baslik: 'Açıklama', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const VARDIYA: IParametreSeti = {
  id: 'personel.vardiya',
  baslik: 'Vardiya Tanımı',
  simge: '⏰',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'vardiya_adi', baslik: 'Vardiya Adı', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'baslangic_saat', baslik: 'Başlangıç Saati', turu: 'Saat' },
    { ismi: 'bitis_saat', baslik: 'Bitiş Saati', turu: 'Saat' },
    { ismi: 'gunler', baslik: 'Günler', turu: 'Liste', ayarlar: { secenekler: ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'] } },
  ] as IParametre[],
};

const PERSONEL_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.personeller',
  baslik: 'Personel Yönetimi',
  simge: '👥',
  renk: '#52c41a',
  kaynak: 'kod',
  sira: 2,
  altGruplar: [PERSONEL_KAYIT, IZIN_KAYIT, VARDIYA],
};

// =============================================
// 3. IoT CİHAZ YÖNETİMİ
// =============================================
const CIHAZ_KAYIT: IParametreSeti = {
  id: 'cihaz.kayit',
  baslik: 'Cihaz Kaydı',
  simge: '📡',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'cihaz_adi', baslik: 'Cihaz Adı', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'cihaz_tipi', baslik: 'Cihaz Tipi', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Kart Okuyucu', 'CNC', 'Lamba Kontrolü', 'Makine Takip', 'Sensör', 'Diğer'] } },
    { ismi: 'seri_no', baslik: 'Seri No', turu: 'Yazı' },
    { ismi: 'ip_adresi', baslik: 'IP Adresi', turu: 'Yazı' },
    { ismi: 'mac_adresi', baslik: 'MAC Adresi', turu: 'Yazı' },
    { ismi: 'konum', baslik: 'Konum', turu: 'Konum' },
    { ismi: 'firmware', baslik: 'Firmware Sürümü', turu: 'Yazı' },
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Aktif', 'Pasif', 'Arızalı', 'Bakımda'] }, degeri: 'Aktif' },
    { ismi: 'notlar', baslik: 'Notlar', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CIHAZ_OLAY: IParametreSeti = {
  id: 'cihaz.olay',
  baslik: 'Cihaz Olayı',
  simge: '⚡',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'olay_tipi', baslik: 'Olay Tipi', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Bağlantı', 'Kopma', 'Veri', 'Hata', 'Uyarı', 'Bilgi'] } },
    { ismi: 'cihaz_id', baslik: 'Cihaz', turu: 'Yazı' },
    { ismi: 'deger', baslik: 'Değer', turu: 'Yazı' },
    { ismi: 'detay', baslik: 'Detay', turu: 'Yazı Alanı' },
    { ismi: 'zaman', baslik: 'Zaman', turu: 'Tarih Saat' },
  ] as IParametre[],
};

const CIHAZ_KOMUT: IParametreSeti = {
  id: 'cihaz.komut',
  baslik: 'Cihaz Komutu',
  simge: '🎮',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'komut_adi', baslik: 'Komut', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'hedef_cihaz', baslik: 'Hedef Cihaz', turu: 'Yazı' },
    { ismi: 'parametreler_json', baslik: 'Parametreler (JSON)', turu: 'Kod' },
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Bekliyor', 'Gönderildi', 'Başarılı', 'Hata'] }, degeri: 'Bekliyor' },
  ] as IParametre[],
};

const CIHAZ_TETIKLEYICI: IParametreSeti = {
  id: 'cihaz.tetikleyici',
  baslik: 'Tetikleyici',
  simge: '🔔',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'tetik_adi', baslik: 'Tetikleyici Adı', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'kosul', baslik: 'Koşul', turu: 'Kod' },
    { ismi: 'aksiyon', baslik: 'Aksiyon', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Bildirim', 'Komut', 'Webhook', 'Log'] } },
    { ismi: 'aktif', baslik: 'Aktif', turu: 'Anahtar', degeri: true },
  ] as IParametre[],
};

const CIHAZ_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.cihazlar',
  baslik: 'IoT Cihaz Yönetimi',
  simge: '📡',
  renk: '#fa8c16',
  kaynak: 'kod',
  sira: 3,
  altGruplar: [CIHAZ_KAYIT, CIHAZ_OLAY, CIHAZ_KOMUT, CIHAZ_TETIKLEYICI],
};

// =============================================
// 4. DENETİM & LOGLAMA
// =============================================
const DENETIM_KAYIT: IParametreSeti = {
  id: 'denetim.kayit',
  baslik: 'Denetim Kaydı',
  simge: '📋',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'islem_tipi', baslik: 'İşlem Tipi', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Ekleme', 'Güncelleme', 'Silme', 'Görüntüleme', 'Giriş', 'Çıkış'] } },
    { ismi: 'kullanici', baslik: 'Kullanıcı', turu: 'Yazı' },
    { ismi: 'hedef', baslik: 'Hedef Kayıt', turu: 'Yazı' },
    { ismi: 'detay', baslik: 'Detay', turu: 'Yazı Alanı' },
    { ismi: 'ip', baslik: 'IP Adresi', turu: 'Yazı' },
  ] as IParametre[],
};

const GIRIS_CIKIS: IParametreSeti = {
  id: 'denetim.giris_cikis',
  baslik: 'Giriş/Çıkış',
  simge: '🚪',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'personel', baslik: 'Personel', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'yon', baslik: 'Yön', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Giriş', 'Çıkış'] } },
    { ismi: 'zaman', baslik: 'Zaman', turu: 'Tarih Saat' },
    { ismi: 'cihaz', baslik: 'Cihaz', turu: 'Yazı' },
    { ismi: 'kart_no', baslik: 'Kart No', turu: 'Yazı' },
  ] as IParametre[],
};

const DENETIM_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.denetim',
  baslik: 'Denetim & Loglama',
  simge: '📋',
  renk: '#722ed1',
  kaynak: 'kod',
  sira: 4,
  altGruplar: [DENETIM_KAYIT, GIRIS_CIKIS],
};

// =============================================
// 5. AJANLAR & GÖREVLER
// =============================================
const AJAN_TANIM: IParametreSeti = {
  id: 'sistem.ajan',
  baslik: 'Ajan Tanımı',
  simge: '🤖',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'ajan_adi', baslik: 'Ajan Adı', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'tipi', baslik: 'Tip', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Socket', 'HTTP', 'Worker', 'Cron'] } },
    { ismi: 'ayarlar_json', baslik: 'Ayarlar (JSON)', turu: 'Kod' },
    { ismi: 'aktif', baslik: 'Aktif', turu: 'Anahtar', degeri: true },
  ] as IParametre[],
};

const GOREV: IParametreSeti = {
  id: 'sistem.gorev',
  baslik: 'Görev',
  simge: '✅',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'baslik', baslik: 'Başlık', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'aciklama', baslik: 'Açıklama', turu: 'Yazı Alanı' },
    { ismi: 'atanan', baslik: 'Atanan Kişi', turu: 'Yazı' },
    { ismi: 'oncelik', baslik: 'Öncelik', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Düşük', 'Normal', 'Yüksek', 'Acil'] }, degeri: 'Normal' },
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Yeni', 'Devam Ediyor', 'Beklemede', 'Tamamlandı', 'İptal'] }, degeri: 'Yeni' },
    { ismi: 'bitis_tarihi', baslik: 'Bitiş Tarihi', turu: 'Tarih' },
    { ismi: 'ilerleme', baslik: 'İlerleme', turu: 'İlerleme Çubuğu', degeri: 0 },
  ] as IParametre[],
};

const BILDIRIM: IParametreSeti = {
  id: 'sistem.bildirim',
  baslik: 'Bildirim',
  simge: '🔔',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'baslik', baslik: 'Başlık', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'icerik', baslik: 'İçerik', turu: 'Yazı Alanı' },
    { ismi: 'tip', baslik: 'Tip', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Bilgi', 'Uyarı', 'Hata', 'Başarı'] } },
    { ismi: 'okundu', baslik: 'Okundu', turu: 'Doğruluk', degeri: false },
  ] as IParametre[],
};

const AJAN_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.ajanlar',
  baslik: 'Sistem',
  simge: '🤖',
  renk: '#13c2c2',
  kaynak: 'kod',
  sira: 5,
  altGruplar: [AJAN_TANIM, GOREV, BILDIRIM],
};

// =============================================
// 6. İLETİŞİM
// =============================================
const MESAJ: IParametreSeti = {
  id: 'iletisim.mesaj',
  baslik: 'Mesaj',
  simge: '💬',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'gonderen', baslik: 'Gönderen', turu: 'Yazı' },
    { ismi: 'alici', baslik: 'Alıcı', turu: 'Yazı' },
    { ismi: 'icerik', baslik: 'İçerik', turu: 'Yazı Alanı' },
    { ismi: 'okundu', baslik: 'Okundu', turu: 'Doğruluk', degeri: false },
  ] as IParametre[],
};

const ILETISIM_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.iletisim',
  baslik: 'İletişim',
  simge: '💬',
  renk: '#eb2f96',
  kaynak: 'kod',
  sira: 6,
  altGruplar: [MESAJ],
};

// =============================================
// 7. TİCARET
// =============================================
const TEKLIF: IParametreSeti = {
  id: 'ticaret.teklif',
  baslik: 'Teklif',
  simge: '📄',
  parametreler: [
    { ismi: 'musteri', baslik: 'Müşteri', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'urunler', baslik: 'Ürünler', turu: 'Tablo' },
    { ismi: 'toplam', baslik: 'Toplam', turu: 'Para' },
    { ismi: 'para_birimi', baslik: 'Para Birimi', turu: 'Açılır Kutu', ayarlar: { secenekler: ['TRY', 'USD', 'EUR'] }, degeri: 'TRY' },
    { ismi: 'gecerlilik', baslik: 'Geçerlilik Tarihi', turu: 'Tarih' },
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Taslak', 'Gönderildi', 'Kabul', 'Red', 'Süresi Doldu'] }, degeri: 'Taslak' },
  ] as IParametre[],
};

const SIPARIS: IParametreSeti = {
  id: 'ticaret.siparis',
  baslik: 'Sipariş',
  simge: '📦',
  parametreler: [
    { ismi: 'teklif_ref', baslik: 'Teklif Referansı', turu: 'Yazı' },
    { ismi: 'musteri', baslik: 'Müşteri', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'urunler', baslik: 'Ürünler', turu: 'Tablo' },
    { ismi: 'toplam', baslik: 'Toplam', turu: 'Para' },
    { ismi: 'teslimat_tarihi', baslik: 'Teslimat Tarihi', turu: 'Tarih' },
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Yeni', 'Üretimde', 'Hazır', 'Kargoda', 'Teslim Edildi', 'İptal'] }, degeri: 'Yeni' },
    { ismi: 'ilerleme', baslik: 'İlerleme', turu: 'İlerleme Çubuğu', degeri: 0 },
  ] as IParametre[],
};

const KARE_KOD: IParametreSeti = {
  id: 'ticaret.kare_kod',
  baslik: 'Kare Kod',
  simge: '📱',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'kod', baslik: 'Kod Değeri', turu: 'KareKod', ayarlar: { zorunlu: true } },
    { ismi: 'tip', baslik: 'Tip', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Ürün', 'Sipariş', 'Lokasyon', 'Ekipman', 'Diğer'] } },
    { ismi: 'iliskili_kayit', baslik: 'İlişkili Kayıt ID', turu: 'Yazı' },
  ] as IParametre[],
};

const TICARET_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.ticaret',
  baslik: 'Ticaret',
  simge: '💰',
  renk: '#faad14',
  kaynak: 'kod',
  sira: 7,
  altGruplar: [TEKLIF, SIPARIS, KARE_KOD],
};

// =============================================
// 8. MAİL SİSTEMİ
// =============================================
const MAIL_HESAP: IParametreSeti = {
  id: 'mail.hesap',
  baslik: 'Mail Hesabi',
  simge: '📧',
  sayfaKurallari: { yeniSayfaEngelle: true, maxSayfa: 1 },
  parametreler: [
    { ismi: 'host', baslik: 'Host', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'port', baslik: 'Port', turu: 'Sayı', degeri: 993 },
    { ismi: 'email', baslik: 'E-posta', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'sifre', baslik: 'Sifre', turu: 'Yazı' },
    { ismi: 'guvenlik', baslik: 'Guvenlik', turu: 'Açılır Kutu', ayarlar: { secenekler: ['SSL', 'TLS', 'STARTTLS'] }, degeri: 'SSL' },
  ] as IParametre[],
};

const MAIL_MESAJ: IParametreSeti = {
  id: 'mail.mesaj',
  baslik: 'Mail Mesaji',
  simge: '✉️',
  sayfaKurallari: { yeniSayfaEngelle: true, icerikEngelle: true },
  parametreler: [
    { ismi: 'kimden', baslik: 'Kimden', turu: 'Yazı' },
    { ismi: 'kime', baslik: 'Kime', turu: 'Yazı' },
    { ismi: 'konu', baslik: 'Konu', turu: 'Yazı' },
    { ismi: 'yon', baslik: 'Yon', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Gelen', 'Giden'] } },
    { ismi: 'tarih', baslik: 'Tarih', turu: 'Tarih Saat' },
    { ismi: 'messageId', baslik: 'Message ID', turu: 'Yazı' },
    { ismi: 'uid', baslik: 'IMAP UID', turu: 'Sayı' },
    { ismi: 'okundu', baslik: 'Okundu', turu: 'Doğruluk', degeri: false },
  ] as IParametre[],
};

const MAIL_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.mail',
  baslik: 'Mail Sistemi',
  simge: '📧',
  renk: '#1890ff',
  kaynak: 'kod',
  sira: 8,
  altGruplar: [MAIL_HESAP, MAIL_MESAJ],
};

// =============================================
// 9. ÜRETİM YÖNETİMİ
// =============================================
const IS_EMRI: IParametreSeti = {
  id: 'uretim.is-emri',
  baslik: 'İş Emri Tanımı',
  simge: '📋',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'emirNo', baslik: 'Emir No', turu: 'Otomatik Kod', ayarlar: { prefix: 'IE', format: '{PREFIX}-{YIL}-{SAYI:3}' }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'urunAdi', baslik: 'Ürün Adı', turu: 'Yazı', ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'urunKodu', baslik: 'Ürün Kodu', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'miktar', baslik: 'Miktar', turu: 'Sayı', ayarlar: { min: 1 }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'birim', baslik: 'Birim', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Adet', 'Kg', 'Metre', 'Litre', 'Ton', 'Takım'] }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'malzeme', baslik: 'Malzeme', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Çelik', 'Alüminyum', 'Pirinç', 'Dökme Demir', 'Paslanmaz', 'Plastik'] }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'oncelik', baslik: 'Öncelik', turu: 'Açılır Kutu', ayarlar: { secenekler: [{ label: 'Normal', value: 'normal', renk: '#52c41a' }, { label: 'Acil', value: 'acil', renk: '#fa8c16' }, { label: 'Kritik', value: 'kritik', renk: '#f5222d' }], itemSablon: { aktif: true, renkGoster: true } }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Planlandı', 'Başladı', 'Devam Ediyor', 'Beklemede', 'Tamamlandı', 'İptal'] }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'baslangicTarihi', baslik: 'Başlangıç Tarihi', turu: 'Tarih', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'hedefTarih', baslik: 'Hedef Tarih', turu: 'Tarih', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'sorumlu', baslik: 'Sorumlu', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'aciklama', baslik: 'Açıklama', turu: 'Yazı Alanı', kontroller: [], hatalar: [], uyarilar: [] },
  ] as IParametre[],
};

const KALITE_KONTROL: IParametreSeti = {
  id: 'uretim.kalite-kontrol',
  baslik: 'Kalite Kontrol Formu',
  simge: '✅',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'kontrolNo', baslik: 'Kontrol No', turu: 'Otomatik Kod', ayarlar: { prefix: 'KK', format: '{PREFIX}-{YIL}-{SAYI:3}' }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'isEmriRef', baslik: 'İş Emri Referansı', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'urunAdi', baslik: 'Ürün Adı', turu: 'Yazı', ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'partNo', baslik: 'Part No', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'olcumDegeri', baslik: 'Ölçüm Değeri', turu: 'Sayı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'toleransAlt', baslik: 'Tolerans Alt', turu: 'Sayı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'toleransUst', baslik: 'Tolerans Üst', turu: 'Sayı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'sonuc', baslik: 'Sonuç', turu: 'Açılır Kutu', ayarlar: { secenekler: [{ label: 'Uygun', value: 'uygun', renk: '#52c41a' }, { label: 'Uygun Değil', value: 'uygun_degil', renk: '#f5222d' }, { label: 'Şartlı Kabul', value: 'sartli', renk: '#faad14' }], itemSablon: { aktif: true, renkGoster: true } }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'hataTanimi', baslik: 'Hata Tanımı', turu: 'Yazı Alanı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'kontrolEden', baslik: 'Kontrol Eden', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'onaylayan', baslik: 'Onaylayan', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
  ] as IParametre[],
};

const FIRE_KAYDI: IParametreSeti = {
  id: 'uretim.fire-kaydi',
  baslik: 'Fire/Hurda Kaydı',
  simge: '🗑️',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'kayitNo', baslik: 'Kayıt No', turu: 'Otomatik Kod', ayarlar: { prefix: 'FR', format: '{PREFIX}-{YIL}-{SAYI:3}' }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'isEmriRef', baslik: 'İş Emri Referansı', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'urunAdi', baslik: 'Ürün Adı', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'fireAdedi', baslik: 'Fire Adedi', turu: 'Sayı', ayarlar: { min: 1 }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'fireSebebi', baslik: 'Fire Sebebi', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Ölçü Hatası', 'Malzeme Hatası', 'Makine Arızası', 'Operatör Hatası', 'Tasarım Hatası', 'Diğer'] }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'aciklama', baslik: 'Açıklama', turu: 'Yazı Alanı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'raporEden', baslik: 'Rapor Eden', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
  ] as IParametre[],
};

const URETIM_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.uretim',
  baslik: 'Üretim Yönetimi',
  simge: '⚙️',
  renk: '#f5222d',
  kaynak: 'kod',
  sira: 9,
  altGruplar: [IS_EMRI, KALITE_KONTROL, FIRE_KAYDI],
};

// =============================================
// 10. BAKIM YÖNETİMİ
// =============================================
const BAKIM_TALEP: IParametreSeti = {
  id: 'bakim.talep',
  baslik: 'Bakım Talebi',
  simge: '🔧',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'talepNo', baslik: 'Talep No', turu: 'Otomatik Kod', ayarlar: { prefix: 'BT', format: '{PREFIX}-{YIL}-{SAYI:3}' }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'makineAdi', baslik: 'Makine Adı', turu: 'Yazı', ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'makineKodu', baslik: 'Makine Kodu', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'arizaTuru', baslik: 'Arıza Türü', turu: 'Açılır Kutu', ayarlar: { secenekler: [{ label: 'Mekanik', value: 'mekanik', simge: '🔩' }, { label: 'Elektrik', value: 'elektrik', simge: '⚡' }, { label: 'Hidrolik', value: 'hidrolik', simge: '💧' }, { label: 'Pnömatik', value: 'pnomatic', simge: '💨' }, { label: 'Yazılım', value: 'yazilim', simge: '💻' }, { label: 'Diğer', value: 'diger', simge: '❓' }], itemSablon: { aktif: true, simgeGoster: true } }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'aciliyet', baslik: 'Aciliyet', turu: 'Açılır Kutu', ayarlar: { secenekler: [{ label: 'Düşük', value: 'dusuk', renk: '#52c41a' }, { label: 'Orta', value: 'orta', renk: '#faad14' }, { label: 'Yüksek', value: 'yuksek', renk: '#fa8c16' }, { label: 'Acil Durum', value: 'acil', renk: '#f5222d' }], itemSablon: { aktif: true, renkGoster: true } }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'aciklama', baslik: 'Açıklama', turu: 'Yazı Alanı', ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'raporEden', baslik: 'Rapor Eden', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
  ] as IParametre[],
};

const BAKIM_PLANLAMA: IParametreSeti = {
  id: 'bakim.planlama',
  baslik: 'Periyodik Bakım Planı',
  simge: '📅',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'makineAdi', baslik: 'Makine Adı', turu: 'Yazı', ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'bakimTuru', baslik: 'Bakım Türü', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Günlük Kontrol', 'Haftalık Bakım', 'Aylık Bakım', '3 Aylık Bakım', '6 Aylık Bakım', 'Yıllık Revizyon'] }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'sonBakimTarihi', baslik: 'Son Bakım Tarihi', turu: 'Tarih', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'sonrakiBakimTarihi', baslik: 'Sonraki Bakım Tarihi', turu: 'Tarih', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'sorumlu', baslik: 'Sorumlu', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'kontrolListesi', baslik: 'Kontrol Listesi', turu: 'Yazı Alanı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'notlar', baslik: 'Notlar', turu: 'Yazı Alanı', kontroller: [], hatalar: [], uyarilar: [] },
  ] as IParametre[],
};

const BAKIM_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.bakim',
  baslik: 'Bakım Yönetimi',
  simge: '🔧',
  renk: '#fa8c16',
  kaynak: 'kod',
  sira: 10,
  altGruplar: [BAKIM_TALEP, BAKIM_PLANLAMA],
};

// =============================================
// 11. STOK & MALZEME
// =============================================
const MALZEME_KARTI: IParametreSeti = {
  id: 'stok.malzeme',
  baslik: 'Malzeme Kartı',
  simge: '🏷️',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'malzemeKodu', baslik: 'Malzeme Kodu', turu: 'Yazı', ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'malzemeAdi', baslik: 'Malzeme Adı', turu: 'Yazı', ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'kategori', baslik: 'Kategori', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Hammadde', 'Yarı Mamul', 'Mamül', 'Yardımcı Malzeme', 'Sarf Malzeme'] }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'birim', baslik: 'Birim', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Adet', 'Kg', 'Metre', 'Litre', 'Ton', 'Takım', 'Paket'] }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'stokMiktari', baslik: 'Stok Miktarı', turu: 'Sayı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'minimumStok', baslik: 'Minimum Stok', turu: 'Sayı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'birimFiyat', baslik: 'Birim Fiyat', turu: 'Sayı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'paraBirimi', baslik: 'Para Birimi', turu: 'Açılır Kutu', ayarlar: { secenekler: ['TRY', 'USD', 'EUR'] }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'depoKonumu', baslik: 'Depo Konumu', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'tedarikci', baslik: 'Tedarikçi', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
  ] as IParametre[],
};

const STOK_HAREKET: IParametreSeti = {
  id: 'stok.hareket',
  baslik: 'Stok Hareketi',
  simge: '🔄',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'hareketNo', baslik: 'Hareket No', turu: 'Otomatik Kod', ayarlar: { prefix: 'SH', format: '{PREFIX}-{YIL}-{SAYI:3}' }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'malzemeKodu', baslik: 'Malzeme Kodu', turu: 'Yazı', ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'hareketTuru', baslik: 'Hareket Türü', turu: 'Açılır Kutu', ayarlar: { secenekler: [{ label: 'Giriş', value: 'giris', renk: '#52c41a' }, { label: 'Çıkış', value: 'cikis', renk: '#f5222d' }, { label: 'Transfer', value: 'transfer', renk: '#1890ff' }, { label: 'Sayım Farkı', value: 'sayim', renk: '#faad14' }], itemSablon: { aktif: true, renkGoster: true } }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'miktar', baslik: 'Miktar', turu: 'Sayı', ayarlar: { min: 1 }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'birim', baslik: 'Birim', turu: 'Açılır Kutu', ayarlar: { secenekler: ['Adet', 'Kg', 'Metre', 'Litre'] }, kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'isEmriRef', baslik: 'İş Emri Referansı', turu: 'Yazı', kontroller: [], hatalar: [], uyarilar: [] },
    { ismi: 'aciklama', baslik: 'Açıklama', turu: 'Yazı Alanı', kontroller: [], hatalar: [], uyarilar: [] },
  ] as IParametre[],
};

const STOK_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.stok',
  baslik: 'Stok & Malzeme',
  simge: '📦',
  renk: '#722ed1',
  kaynak: 'kod',
  sira: 11,
  altGruplar: [MALZEME_KARTI, STOK_HAREKET],
};

// =============================================
// HMI & DONANIM
// =============================================

const KART_OKUYUCU_DURUM: IParametreSeti = {
  id: 'hmi.kart-okuyucu',
  baslik: 'Kart Okuyucu Durumu',
  simge: '💳',
  aciklama: 'NodeMCU RFID/NFC kart okuyucusunun anlık bağlantı ve kart durumunu gösterir',
  bilesen: 'hmi-kart-okuyucu',
  sayfaKurallari: {
    yeniSayfaEngelle: true,
    maxSayfa: 1,
    icerikEngelle: true,
    dosyaEngelle: true,
    mikrofonEngelle: true,
    uyarDokumEngelle: true,
    youtubeEngelle: true,
    konumEngelle: true,
    metinEngelle: false,
  },
  parametreler: [
    {
      ismi: 'baslik', baslik: 'Başlık', turu: 'Yazı',
      degeri: 'Kart Okuyucu',
      yerTutucu: 'Kart Okuyucu',
      ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
    },
    {
      ismi: 'cihazKimlik', baslik: 'Cihaz Kimliği', turu: 'Yazı',
      yerTutucu: 'modelhane-okuyucu-1 (boş = hepsi)',
      altAciklama: 'Takip edilecek NodeMCU cihaz kimliği — boş bırakılırsa tüm cihazlar izlenir',
      ayarlar: { solSimge: 'wifi' }, kontroller: [], hatalar: [], uyarilar: [],
    },
    {
      ismi: 'kisiIsim', baslik: 'Varsayılan Kişi İsmi', turu: 'Yazı',
      yerTutucu: 'Ör: Fikri Topaloglu',
      altAciklama: 'WS olayında kişi bilgisi gelmiyorsa kullanılır',
      ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
    },
    {
      ismi: 'kisiResim', baslik: 'Kişi Resim URL', turu: 'Yazı',
      yerTutucu: 'https://...',
      ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
    },
  ] as IParametre[],
};

const KART_SAHIBI_GECMISI: IParametreSeti = {
  id: 'hmi.kart-sahibi',
  baslik: 'Kart Sahibi / Kart Geçmişi',
  simge: '🪪',
  aciklama: 'Bir kartı okutup bir kişiye atar; paylaşılan kartta o kartın aylık okuma geçmişini gösterir',
  bilesen: 'hmi-kart-sahibi',
  sayfaKurallari: {
    yeniSayfaEngelle: true,
    maxSayfa: 1,
    icerikEngelle: true,
    dosyaEngelle: true,
    mikrofonEngelle: true,
    uyarDokumEngelle: true,
    youtubeEngelle: true,
    konumEngelle: true,
    metinEngelle: false,
  },
  parametreler: [
    {
      ismi: 'kartUid', baslik: 'Kart UID', turu: 'Yazı',
      altAciklama: 'Kartı okuyucuya okutarak otomatik atanır',
      ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
    },
    {
      ismi: 'sahipIsmi', baslik: 'Kart Sahibi', turu: 'Yazı',
      yerTutucu: 'Ör: Fikri Topaloğlu',
      ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
    },
  ] as IParametre[],
};

const FIRMADA_PANEL: IParametreSeti = {
  id: 'hmi.firmada-panel',
  baslik: 'Firmada Panel',
  simge: '👥',
  aciklama: 'Seçilen kart okuyucularında şu an firmada olan kişileri resim ve isim ile gösterir',
  bilesen: 'hmi-firmada-panel',
  sayfaKurallari: {
    yeniSayfaEngelle: true,
    maxSayfa: 1,
    icerikEngelle: true,
    dosyaEngelle: true,
    mikrofonEngelle: true,
    uyarDokumEngelle: true,
    youtubeEngelle: true,
    konumEngelle: true,
    metinEngelle: false,
  },
  parametreler: [
    {
      ismi: 'baslik', baslik: 'Başlık', turu: 'Yazı',
      degeri: 'Firmada Panel',
      yerTutucu: 'Firmada Panel',
      ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
    },
  ] as IParametre[],
};

const HMI_PERSONEL: IParametreSeti = {
  id: 'hmi.personel',
  baslik: 'Personel',
  simge: '👤',
  bilesen: 'personel',
  parametreler: [
    { turu: 'Yazı', ismi: 'ad', baslik: 'Ad', ayarlar: { zorunlu: true } },
    { turu: 'Yazı', ismi: 'soyad', baslik: 'Soyad', ayarlar: { zorunlu: true } },
    { turu: 'Yazı', ismi: 'sicilNo', baslik: 'Sicil No' },
    { turu: 'Yazı', ismi: 'unvan', baslik: 'Unvan' },
    { turu: 'Yazı', ismi: 'gorev', baslik: 'Gorev' },
    { turu: 'Yazı', ismi: 'telefon', baslik: 'Telefon' },
    { turu: 'Yazı', ismi: 'eposta', baslik: 'E-posta' },
  ] as IParametre[],
};

const HMI_MAKINE_TANIMI: IParametreSeti = {
  id: 'hmi.makine-tanimi',
  baslik: 'Makine Tanımı',
  simge: '⚙️',
  bilesen: 'makine-tanimi',
  parametreler: [
    { turu: 'Yazı', ismi: 'makineAdi', baslik: 'Makine Adi', ayarlar: { zorunlu: true } },
    { turu: 'Yazı', ismi: 'makineKodu', baslik: 'Makine Kodu' },
    { turu: 'Yazı', ismi: 'tip', baslik: 'Tip' },
    { turu: 'Yazı', ismi: 'konum', baslik: 'Konum' },
  ] as IParametre[],
};

const HMI_DEPARTMAN: IParametreSeti = {
  id: 'hmi.departman',
  baslik: 'Departman',
  simge: '🏢',
  bilesen: 'departman',
  parametreler: [
    { ismi: 'departmanAdi', baslik: 'Departman Adı', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'departmanKodu', baslik: 'Departman Kodu', turu: 'Yazı' },
    { ismi: 'aciklama', baslik: 'Açıklama', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const HMI_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.hmi',
  baslik: 'HMI & Donanım',
  simge: '🖥️',
  renk: 'linear-gradient(135deg, #003d5c, #006b8f)',
  kaynak: 'kod',
  sira: 12,
  altGruplar: [KART_OKUYUCU_DURUM, KART_SAHIBI_GECMISI, FIRMADA_PANEL, HMI_PERSONEL, HMI_MAKINE_TANIMI, HMI_DEPARTMAN],
};

// =============================================
// 13 — Cam İşleme
// =============================================

const _CAM_TR = `{i:'[iİ]',İ:'[iİ]',ı:'[ıI]',I:'[ıI]',ş:'[şŞ]',Ş:'[şŞ]',ç:'[çÇ]',Ç:'[çÇ]',ö:'[öÖ]',Ö:'[öÖ]',ü:'[üÜ]',Ü:'[üÜ]',ğ:'[ğĞ]',Ğ:'[ğĞ]'}`;
const _CAM_RX = `var trMap = ${_CAM_TR}; var rx = deger ? Array.from(deger).map(function(c){return trMap[c]||c}).join('') : '';`;
const _CAM_LOOKUP = `{"$lookup":{"from":"hareketler","localField":"veri.icerikler","foreignField":"_id","as":"veri.icerikler"}}`;
// secenekItm icinde kullanilan yardimci: hem parametreler[] hem flat ek.* 'den deger okur
const _CAM_PVAL = `function _pv(n){var v=(p.find(function(x){return x.ismi===n})||{}).degeri; if(v!=null&&v!=='') return v; var e=ic?.ek; return e?e[n]||'':'';}`;
const _CAM_FALLBACK = `if(!_l){var h=ic?.html||ic?.aciklama||''; if(h){var t=h.replace(/<[^>]*>/g,'').trim(); if(t) _l=t.substring(0,40);}} if(!_l) _l='#'+String(scnk._id).slice(-6);`;

function _camSecenekItm(simge: string, labelFields: string[], aciklamaFields: string[], aciklamaJoin = ' · '): string {
  const labelParts = labelFields.map(f => `_pv('${f}')`).join('||');
  const aciklamaParts = aciklamaFields.map(f => `_pv('${f}')`);
  const aciklamaStr = aciklamaParts.length > 1
    ? `[${aciklamaParts.join(',')}].filter(Boolean).join('${aciklamaJoin}')`
    : (aciklamaParts[0] || `''`);
  return `var ic=scnk.veri?.icerikler?.[0]; var p=(ic?.ek?.parametreler||[]); ${_CAM_PVAL} var _l=${labelParts}||''; ${_CAM_FALLBACK} var _a=${aciklamaStr}; return {value:scnk._id,label:_l,simge:'${simge}',aciklama:_a}`;
}

function _camFapiKutu(ismi: string, baslik: string, simge: string, setId: string, aramaAlani: string, labelFields: string[], aciklamaFields: string[], coklu = false): any {
  const ayarlar: any = {
    arama: true, silme: true, solSimge: simge, coklu,
    itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true },
    secenekItm: _camSecenekItm(simge, labelFields, aciklamaFields),
    hizliEkle: baslik, hizliEkleSetId: setId,
    fapiAyarlar: {
      vt: 'FikoYT.sistem.hareketler',
      solSimge: { baslik: 'Cam', renkArka: '#0891b2', renkYazi: '#fff' },
      pipeFunc: `${_CAM_RX} var m={"silindi":{"$ne":true}}; var pipe=[{"$match":m},${_CAM_LOOKUP},{"$match":{"veri.icerikler.ek._secilenSetId":"${setId}"}}]; if(rx) pipe.push({"$match":{"$or":[{"veri.icerikler.ek.parametreler":{"$elemMatch":{"ismi":"${aramaAlani}","degeri":{"$regex":rx,"$options":"i"}}}},{"veri.icerikler.ek.${aramaAlani}":{"$regex":rx,"$options":"i"}}]}}); pipe.push({"$sort":{_id:-1}},{"$limit":20},{"$project":{_id:1,"veri.icerikler":1}}); return pipe`,
    },
  };
  return { turu: 'Açılır Kutu', ismi, baslik, ayarlar };
}

function _camFapiKutuRegex(ismi: string, baslik: string, simge: string, setIdRegex: string, aramaAlani: string, labelFields: string[], aciklamaFields: string[], coklu = false): any {
  return {
    turu: 'Açılır Kutu', ismi, baslik, ayarlar: {
      arama: true, silme: true, solSimge: simge, coklu,
      itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true },
      secenekItm: _camSecenekItm(simge, labelFields, aciklamaFields),
      fapiAyarlar: {
        vt: 'FikoYT.sistem.hareketler',
        solSimge: { baslik: 'Cam', renkArka: '#0891b2', renkYazi: '#fff' },
        pipeFunc: `${_CAM_RX} var m={"silindi":{"$ne":true}}; var pipe=[{"$match":m},${_CAM_LOOKUP},{"$match":{"veri.icerikler.ek._secilenSetId":{"$regex":"${setIdRegex}"}}}]; if(rx) pipe.push({"$match":{"$or":[{"veri.icerikler.ek.parametreler":{"$elemMatch":{"ismi":"${aramaAlani}","degeri":{"$regex":rx,"$options":"i"}}}},{"veri.icerikler.ek.${aramaAlani}":{"$regex":rx,"$options":"i"}}]}}); pipe.push({"$sort":{_id:-1}},{"$limit":20},{"$project":{_id:1,"veri.icerikler":1}}); return pipe`,
      },
    },
  };
}

const _PERSONEL_HIZLI_SET_CAM = {
  id: 'hmi.personel', baslik: 'Personel', simge: '👤', kaynak: 'kod',
  parametreler: [
    { turu: 'Yazı', ismi: 'ad', baslik: 'Ad', ayarlar: { zorunlu: true } },
    { turu: 'Yazı', ismi: 'soyad', baslik: 'Soyad', ayarlar: { zorunlu: true } },
  ],
};

function _camPersonelKutu(ismi: string, baslik: string): any {
  return {
    turu: 'Açılır Kutu', ismi, baslik, ayarlar: {
      arama: true, silme: true, solSimge: '👤',
      hizliEkle: 'Personel', hizliEkleSetId: 'hmi.personel', hizliEkleKaynakSetleri: [_PERSONEL_HIZLI_SET_CAM],
      itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true },
      secenekItm: `var ic=scnk.veri?.icerikler?.[0]; var p=(ic?.ek?.parametreler||[]); ${_CAM_PVAL} var ad=_pv('ad'); var soyad=_pv('soyad'); var isim=(ad+' '+soyad).trim(); if(!isim){isim=_pv('unvan')||('Personel #'+String(scnk._id).slice(-4));} return {value:scnk._id,label:isim,simge:'👤',aciklama:[_pv('unvan'),_pv('gorev')].filter(Boolean).join(' · ')}`,
      fapiAyarlar: {
        vt: 'FikoYT.sistem.hareketler',
        solSimge: { baslik: 'HMI', renkArka: '#722ed1', renkYazi: '#fff' },
        pipeFunc: `${_CAM_RX} var m={"silindi":{"$ne":true}}; var pipe=[{"$match":m},${_CAM_LOOKUP},{"$match":{"veri.icerikler.ek._secilenSetId":"hmi.personel"}}]; if(rx) pipe.push({"$match":{"veri.icerikler.ek.parametreler":{"$elemMatch":{"ismi":{"$in":["ad","soyad"]},"degeri":{"$regex":rx,"$options":"i"}}}}}); pipe.push({"$sort":{_id:-1}},{"$limit":15},{"$project":{_id:1,"veri.icerikler":1}}); return pipe`,
      },
    },
  };
}

function _camProjeKutu(ismi: string, baslik: string, coklu = false): any {
  return _camFapiKutuRegex(ismi, baslik, '📂', '^hmi\\\\.proje', 'projeAdi',
    ['projeAdi', 'kategoriAdi'], ['musteri', 'durum', 'oncelik'], coklu);
}

function _camSiparisKutu(ismi: string, baslik: string, coklu = false): any {
  return _camFapiKutu(ismi, baslik, '🛒', 'hmi.siparis', 'siparisNo',
    ['siparisNo', 'urunAdi'], ['musteri', 'durum'], coklu);
}

const CAM_MALZEME_TANIMI: IParametreSeti = {
  id: 'cam.malzeme-tanimi',
  baslik: 'Malzeme Tanımı',
  simge: '🧊',
  bilesen: 'cam-malzeme-tanimi',
  sayfaKurallari: { yeniSayfaEngelle: true },
  parametreler: [
    { ismi: 'malzemeAdi', baslik: 'Malzeme Adı', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'pilesmi', baslik: 'Tür', turu: 'Yazı' },
    { ismi: 'kalinlik', baslik: 'Kalınlık (mm)', turu: 'Sayı' },
    { ismi: 'renk', baslik: 'Renk', turu: 'Yazı' },
    { ismi: 'birimFiyat', baslik: 'Birim Fiyat (m²)', turu: 'Sayı' },
    { ismi: 'stokMiktari', baslik: 'Stok Miktarı', turu: 'Sayı' },
    { ismi: 'minimumStok', baslik: 'Min. Stok Seviyesi', turu: 'Sayı' },
    { ismi: 'tedarikci', baslik: 'Tedarikçi', turu: 'Yazı' },
    { ismi: 'notlar', baslik: 'Notlar', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CAM_PARCA_DURUM: IParametreSeti = {
  id: 'cam.parca.durum', baslik: 'Durum Güncelleme', simge: '🔄',
  parametreler: [
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', degeri: 'Bekliyor', ayarlar: { zorunlu: true, secenekler: [
      { label: 'Bekliyor', value: 'Bekliyor', renk: '#8c8c8c' },
      { label: 'Kütükte', value: 'Kütükte', renk: '#1890ff' },
      { label: "CNC'de", value: "CNC'de", renk: '#722ed1' },
      { label: 'Tamamlandı', value: 'Tamamlandı', renk: '#52c41a' },
      { label: 'Red', value: 'Red', renk: '#ff4d4f' },
      { label: 'Hurda', value: 'Hurda', renk: '#434343' },
    ], itemSablon: { aktif: true, renkGoster: true } } },
    _camPersonelKutu('sorumlu', 'Sorumlu'),
    { ismi: 'notlar', baslik: 'Açıklama', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CAM_KUTUK_DURUM: IParametreSeti = {
  id: 'cam.kutuk.durum', baslik: 'Durum Güncelleme', simge: '🔄',
  parametreler: [
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', degeri: 'Bekliyor', ayarlar: { zorunlu: true, secenekler: [
      { label: 'Bekliyor', value: 'Bekliyor', renk: '#8c8c8c' },
      { label: 'Görüldü', value: 'Görüldü', renk: '#1890ff' },
      { label: 'Hazırlanıyor', value: 'Hazırlanıyor', renk: '#fa8c16' },
      { label: 'Tamamlandı', value: 'Tamamlandı', renk: '#52c41a' },
      { label: 'Red', value: 'Red', renk: '#ff4d4f' },
    ], itemSablon: { aktif: true, renkGoster: true } } },
    _camPersonelKutu('sorumlu', 'Sorumlu'),
    { ismi: 'notlar', baslik: 'Açıklama', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CAM_CNC_DURUM: IParametreSeti = {
  id: 'cam.cnc.durum', baslik: 'Durum Güncelleme', simge: '🔄',
  parametreler: [
    { ismi: 'durum', baslik: 'Durum', turu: 'Açılır Kutu', degeri: 'Bekliyor', ayarlar: { zorunlu: true, secenekler: [
      { label: 'Bekliyor', value: 'Bekliyor', renk: '#8c8c8c' },
      { label: 'İşleniyor', value: 'İşleniyor', renk: '#fa8c16' },
      { label: 'Tamamlandı', value: 'Tamamlandı', renk: '#52c41a' },
      { label: 'Red', value: 'Red', renk: '#ff4d4f' },
      { label: 'Arıza', value: 'Arıza', renk: '#cf1322' },
    ], itemSablon: { aktif: true, renkGoster: true } } },
    _camPersonelKutu('sorumlu', 'Sorumlu'),
    { ismi: 'notlar', baslik: 'Açıklama', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CAM_KALITE: IParametreSeti = {
  id: 'cam.kalite', baslik: 'Kalite Kontrol', simge: '🎯',
  parametreler: [
    { ismi: 'sonuc', baslik: 'Sonuç', turu: 'Açılır Kutu', ayarlar: { zorunlu: true, secenekler: [
      { label: 'Kabul', value: 'Kabul', renk: '#52c41a' },
      { label: 'Koşullu Kabul', value: 'Koşullu Kabul', renk: '#fa8c16' },
      { label: 'Red', value: 'Red', renk: '#ff4d4f' },
    ], itemSablon: { aktif: true, renkGoster: true } } },
    { ismi: 'olculenEn', baslik: 'Ölçülen En (mm)', turu: 'Sayı' },
    { ismi: 'olculenBoy', baslik: 'Ölçülen Boy (mm)', turu: 'Sayı' },
    { ismi: 'olculenYukseklik', baslik: 'Ölçülen Yükseklik (mm)', turu: 'Sayı' },
    _camPersonelKutu('kontrolEden', 'Kontrol Eden'),
    { ismi: 'notlar', baslik: 'Notlar', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CAM_PARCA: IParametreSeti = {
  id: 'cam.parca',
  baslik: 'Cam Parça',
  simge: '🔷',
  bilesen: 'cam-parca',
  sayfaKurallari: { yeniSayfaEngelle: true },
  altKartSablonlari: [CAM_PARCA_DURUM, CAM_KALITE],
  parametreler: [
    { ismi: 'parcaAdi', baslik: 'Parça Adı', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'revizyon', baslik: 'Revizyon', turu: 'Yazı', degeri: 'v1' },
    { ismi: 'en', baslik: 'En (mm)', turu: 'Sayı' },
    { ismi: 'boy', baslik: 'Boy (mm)', turu: 'Sayı' },
    { ismi: 'yukseklik', baslik: 'Yükseklik (mm)', turu: 'Sayı' },
    { ismi: 'tolerans', baslik: 'Tolerans', turu: 'Yazı' },
    { ismi: 'malzeme', baslik: 'Malzeme', turu: 'Yazı' },
    { ismi: 'adet', baslik: 'Adet', turu: 'Sayı', degeri: 1 },
    { ismi: 'oncelik', baslik: 'Öncelik', turu: 'Yazı', degeri: 'Normal' },
    { ismi: 'siparisRef', baslik: 'Sipariş', turu: 'Yazı' },
    { ismi: 'hedefTarih', baslik: 'Hedef Bitiş', turu: 'Tarih-Saat' },
    { ismi: 'notlar', baslik: 'Notlar', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CAM_KUTUK: IParametreSeti = {
  id: 'cam.kutuk',
  baslik: 'Kütük',
  simge: '🪵',
  bilesen: 'cam-kutuk',
  sayfaKurallari: { yeniSayfaEngelle: true },
  altKartSablonlari: [CAM_KUTUK_DURUM],
  parametreler: [
    { ismi: 'malzeme', baslik: 'Malzeme', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'en', baslik: 'En (mm)', turu: 'Sayı' },
    { ismi: 'boy', baslik: 'Boy (mm)', turu: 'Sayı' },
    { ismi: 'yukseklik', baslik: 'Yükseklik (mm)', turu: 'Sayı' },
    { ismi: 'adet', baslik: 'Adet', turu: 'Sayı', degeri: 1 },
    { ismi: 'atanan', baslik: 'Kütükçü', turu: 'Yazı' },
    { ismi: 'notlar', baslik: 'Notlar', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CAM_ANDON: IParametreSeti = {
  id: 'cam.andon', baslik: 'Duruş / Yardım', simge: '🚨',
  parametreler: [
    { ismi: 'durusSebebi', baslik: 'Duruş Sebebi', turu: 'Açılır Kutu', ayarlar: { zorunlu: true, secenekler: [
      { label: 'Malzeme Eksikliği', value: 'Malzeme Eksikliği', renk: '#fa8c16' },
      { label: 'Kalıp/Takım Arızası', value: 'Kalıp/Takım Arızası', renk: '#ff4d4f' },
      { label: 'Elektrik Kesintisi', value: 'Elektrik Kesintisi', renk: '#cf1322' },
      { label: 'Kumanda Hatası', value: 'Kumanda Hatası', renk: '#722ed1' },
      { label: 'Bakım İhtiyacı', value: 'Bakım İhtiyacı', renk: '#1890ff' },
      { label: 'Kalite Sorunu', value: 'Kalite Sorunu', renk: '#eb2f96' },
      { label: 'Diğer', value: 'Diğer', renk: '#8c8c8c' },
    ], itemSablon: { aktif: true, renkGoster: true } } },
    { ismi: 'durusSuresi', baslik: 'Duruş Süresi (dk)', turu: 'Sayı' },
    _camPersonelKutu('bildiren', 'Bildiren'),
    { ismi: 'cozum', baslik: 'Çözüm / Aksiyon', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CAM_BAKIM: IParametreSeti = {
  id: 'cam.bakim', baslik: 'Bakım Kaydı', simge: '🔧',
  parametreler: [
    { ismi: 'bakimTuru', baslik: 'Bakım Türü', turu: 'Açılır Kutu', ayarlar: { zorunlu: true, secenekler: [
      { label: 'Günlük Kontrol', value: 'Günlük Kontrol', renk: '#52c41a' },
      { label: 'Haftalık Bakım', value: 'Haftalık Bakım', renk: '#1890ff' },
      { label: 'Aylık Bakım', value: 'Aylık Bakım', renk: '#722ed1' },
      { label: 'Arıza Giderme', value: 'Arıza Giderme', renk: '#ff4d4f' },
      { label: 'Parça Değişimi', value: 'Parça Değişimi', renk: '#fa8c16' },
    ], itemSablon: { aktif: true, renkGoster: true } } },
    { ismi: 'makineSaati', baslik: 'Makine Saati', turu: 'Sayı' },
    _camPersonelKutu('bakimci', 'Bakımcı'),
    { ismi: 'yapilanIslem', baslik: 'Yapılan İşlem', turu: 'Yazı Alanı' },
    { ismi: 'sonrakiBakim', baslik: 'Sonraki Bakım Tarihi', turu: 'Tarih-Saat' },
  ] as IParametre[],
};

const CAM_VARDIYA: IParametreSeti = {
  id: 'cam.vardiya', baslik: 'Vardiya Kaydı', simge: '⏰',
  parametreler: [
    { ismi: 'vardiyaTuru', baslik: 'Vardiya', turu: 'Açılır Kutu', ayarlar: { zorunlu: true, secenekler: [
      { label: 'Sabah (06:00-14:00)', value: 'Sabah', renk: '#fa8c16' },
      { label: 'Öğle (14:00-22:00)', value: 'Öğle', renk: '#1890ff' },
      { label: 'Gece (22:00-06:00)', value: 'Gece', renk: '#722ed1' },
    ], itemSablon: { aktif: true, renkGoster: true } } },
    { ismi: 'uretimAdedi', baslik: 'Üretim Adedi', turu: 'Sayı' },
    { ismi: 'redAdedi', baslik: 'Red Adedi', turu: 'Sayı', degeri: 0 },
    _camPersonelKutu('operator', 'Operatör'),
    { ismi: 'devirNotlari', baslik: 'Devir Teslim Notları', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CAM_ENERJI: IParametreSeti = {
  id: 'cam.enerji', baslik: 'Enerji Kaydı', simge: '⚡',
  parametreler: [
    { ismi: 'kwh', baslik: 'Tüketim (kWh)', turu: 'Sayı' },
    { ismi: 'islemSuresi', baslik: 'İşlem Süresi (dk)', turu: 'Sayı' },
    { ismi: 'parcaAdedi', baslik: 'Parça Adedi', turu: 'Sayı' },
    { ismi: 'notlar', baslik: 'Notlar', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CAM_CNC_ISLEM: IParametreSeti = {
  id: 'cam.cnc-islem',
  baslik: 'CNC İşlem',
  simge: '⚙️',
  bilesen: 'cam-cnc-islem',
  sayfaKurallari: { yeniSayfaEngelle: true },
  altKartSablonlari: [CAM_CNC_DURUM, CAM_ANDON, CAM_BAKIM, CAM_KALITE, CAM_VARDIYA, CAM_ENERJI],
  parametreler: [
    { ismi: 'tezgah', baslik: 'Tezgah', turu: 'Yazı' },
    { ismi: 'operator', baslik: 'Operatör', turu: 'Yazı' },
    { ismi: 'oncelik', baslik: 'Öncelik', turu: 'Yazı', degeri: 'Normal' },
    { ismi: 'hedefTarih', baslik: 'Hedef Bitiş', turu: 'Tarih-Saat' },
    { ismi: 'notlar', baslik: 'Notlar', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const CAM_ISLEME_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.cam-isleme',
  baslik: 'Cam İşleme',
  simge: '🔍',
  renk: '#0891b2',
  kaynak: 'kod',
  sira: 13,
  altGruplar: [CAM_MALZEME_TANIMI, CAM_PARCA, CAM_KUTUK, CAM_CNC_ISLEM],
};

// =============================================
// 14 — Kütük Stok
// =============================================
const KUTUK_STOK_HAREKET: IParametreSeti = {
  id: 'kutuk-stok.hareket', baslik: 'Hareket', simge: '🔄',
  bilesen: 'kutuk-stok-hareket',
  parametreler: [
    { ismi: 'tip', baslik: 'Hareket Tipi', turu: 'Açılır Kutu', degeri: 'giris', ayarlar: { zorunlu: true, secenekler: [
      { label: 'Giriş', value: 'giris', renk: '#22c55e' },
      { label: 'Çıkış', value: 'cikis', renk: '#ef4444' },
      { label: 'Sayım', value: 'sayim', renk: '#3b82f6' },
      { label: 'Fire', value: 'fire', renk: '#f59e0b' },
    ], itemSablon: { aktif: true, renkGoster: true } } },
    { ismi: 'miktar', baslik: 'Miktar', turu: 'Sayı', ayarlar: { zorunlu: true, min: 0 } },
    { ismi: 'aciklama', baslik: 'Açıklama', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const KUTUK_STOK: IParametreSeti = {
  id: 'kutuk-stok',
  baslik: 'Kütük Stok',
  simge: '🪵',
  bilesen: 'kutuk-stok',
  sayfaKurallari: { yeniSayfaEngelle: true },
  altKartSablonlari: [KUTUK_STOK_HAREKET],
  parametreler: [
    { ismi: 'isim', baslik: 'İsim', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'en', baslik: 'En (mm)', turu: 'Sayı' },
    { ismi: 'boy', baslik: 'Boy (mm)', turu: 'Sayı' },
    { ismi: 'yukseklik', baslik: 'Yükseklik (mm)', turu: 'Sayı' },
    { ismi: 'birim', baslik: 'Birim', turu: 'Yazı', degeri: 'adet' },
    { ismi: 'uyariLimit', baslik: 'Uyarı Limiti', turu: 'Sayı' },
    { ismi: 'kritikLimit', baslik: 'Kritik Limit', turu: 'Sayı' },
    { ismi: 'notlar', baslik: 'Notlar', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const KUTUK_STOK_PANO: IParametreSeti = {
  id: 'kutuk-stok.pano',
  baslik: 'Stok Panosu',
  simge: '📊',
  bilesen: 'kutuk-stok-pano',
  parametreler: [],
};

const KUTUK_STOK_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.kutuk-stok',
  baslik: 'Kütük Stok',
  simge: '🪵',
  renk: '#b45309',
  kaynak: 'kod',
  sira: 14,
  altGruplar: [KUTUK_STOK, KUTUK_STOK_PANO],
};

// =============================================
// 15 — Genel Stok (kütüğe özel değil; kullanıcı tanımlı özel alanlar)
// =============================================
const GENEL_STOK_HAREKET: IParametreSeti = {
  id: 'genel-stok.hareket', baslik: 'Hareket', simge: '🔄',
  bilesen: 'genel-stok-hareket',
  parametreler: [
    { ismi: 'tip', baslik: 'Hareket Tipi', turu: 'Açılır Kutu', degeri: 'giris', ayarlar: { zorunlu: true, secenekler: [
      { label: 'Giriş', value: 'giris', renk: '#22c55e' },
      { label: 'Çıkış', value: 'cikis', renk: '#ef4444' },
      { label: 'Sayım', value: 'sayim', renk: '#3b82f6' },
      { label: 'Fire', value: 'fire', renk: '#f59e0b' },
    ], itemSablon: { aktif: true, renkGoster: true } } },
    { ismi: 'miktar', baslik: 'Miktar', turu: 'Sayı', ayarlar: { zorunlu: true, min: 0 } },
    { ismi: 'aciklama', baslik: 'Açıklama', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const GENEL_STOK: IParametreSeti = {
  id: 'genel-stok',
  baslik: 'Genel Stok',
  simge: '📦',
  aciklama: 'Kullanıcı tanımlı özel alanlarla genel amaçlı stok kalemi',
  bilesen: 'genel-stok',
  sayfaKurallari: { yeniSayfaEngelle: true },
  altKartSablonlari: [GENEL_STOK_HAREKET],
  parametreler: [
    { ismi: 'isim', baslik: 'İsim', turu: 'Yazı', ayarlar: { zorunlu: true } },
    { ismi: 'birim', baslik: 'Birim', turu: 'Yazı', degeri: 'adet' },
    { ismi: 'uyariLimit', baslik: 'Uyarı Limiti', turu: 'Sayı' },
    { ismi: 'kritikLimit', baslik: 'Kritik Limit', turu: 'Sayı' },
    { ismi: 'ozelAlanlar', baslik: 'Özel Alanlar', turu: 'Tablo', ayarlar: { kolonlar: ['ad', 'deger'] } },
    { ismi: 'notlar', baslik: 'Notlar', turu: 'Yazı Alanı' },
  ] as IParametre[],
};

const GENEL_STOK_PANO: IParametreSeti = {
  id: 'genel-stok.pano',
  baslik: 'Stok Panosu',
  simge: '📊',
  bilesen: 'genel-stok-pano',
  parametreler: [],
};

const GENEL_STOK_GRUBU: IParametreSetiGrubu = {
  id: 'sistem.genel-stok',
  baslik: 'Genel Stok',
  simge: '📦',
  renk: '#6366f1',
  kaynak: 'kod',
  sira: 15,
  altGruplar: [GENEL_STOK, GENEL_STOK_PANO],
};

// =============================================
// EXPORT
// =============================================
export const SISTEM_PARAMETRE_SETLERI: IParametreSetiGrubu[] = [
  FIRMA_GRUBU,
  PERSONEL_GRUBU,
  CIHAZ_GRUBU,
  DENETIM_GRUBU,
  AJAN_GRUBU,
  ILETISIM_GRUBU,
  TICARET_GRUBU,
  MAIL_GRUBU,
  URETIM_GRUBU,
  BAKIM_GRUBU,
  STOK_GRUBU,
  HMI_GRUBU,
  CAM_ISLEME_GRUBU,
  KUTUK_STOK_GRUBU,
  GENEL_STOK_GRUBU,
];

// VT eşleme tablosu: parametre seti id → vt değeri
export const SET_VT_ESLEME: Record<string, string> = {
  'firma.kayit': 'FikoYT.sistem.firmalar',
  'firma.departman': 'FikoYT.sistem.firma.departmanlar',
  'firma.yetki': 'FikoYT.sistem.firma.yetkiler',
  'personel.kayit': 'FikoYT.sistem.firma.personeller',
  'personel.izin': 'FikoYT.sistem.firma.personeller',
  'personel.vardiya': 'FikoYT.sistem.firma.personeller',
  'cihaz.kayit': 'FikoYT.sistem.cihazlar',
  'cihaz.olay': 'FikoYT.sistem.cihaz.olaylar',
  'cihaz.komut': 'FikoYT.sistem.cihaz.komutlar',
  'cihaz.tetikleyici': 'FikoYT.sistem.cihaz.tetikleyiciler',
  'denetim.kayit': 'FikoYT.sistem.denetim',
  'denetim.giris_cikis': 'FikoYT.sistem.giris_cikis',
  'sistem.ajan': 'FikoYT.sistem.ajanlar',
  'sistem.gorev': 'FikoYT.sistem.gorevler',
  'sistem.bildirim': 'FikoYT.sistem.bildirimler',
  'iletisim.mesaj': 'FikoYT.sistem.mesajlar',
  'ticaret.teklif': 'FikoYT.sistem.teklifler',
  'ticaret.siparis': 'FikoYT.sistem.siparisler',
  'ticaret.kare_kod': 'FikoYT.sistem.kare_kodlar',
  'mail.hesap': 'FikoYT.sistem.mail.hesaplar',
  'mail.mesaj': 'FikoYT.sistem.mail.mesajlar',
  'uretim.is-emri': 'FikoYT.sistem.hareketler',
  'uretim.kalite-kontrol': 'FikoYT.sistem.hareketler',
  'uretim.fire-kaydi': 'FikoYT.sistem.hareketler',
  'bakim.talep': 'FikoYT.sistem.hareketler',
  'bakim.planlama': 'FikoYT.sistem.hareketler',
  'stok.malzeme': 'FikoYT.sistem.hareketler',
  'stok.hareket': 'FikoYT.sistem.hareketler',
  'hmi.kart-okuyucu': 'FikoYT.sistem.hmi.kart_okuyucu',
  'hmi.personel': 'FikoYT.sistem.hareketler',
  'hmi.makine-tanimi': 'FikoYT.sistem.hareketler',
  'hmi.departman': 'FikoYT.sistem.hareketler',
  'cam.malzeme-tanimi': 'FikoYT.sistem.hareketler',
  'cam.parca': 'FikoYT.sistem.hareketler',
  'cam.parca.durum': 'FikoYT.sistem.hareketler',
  'cam.kutuk': 'FikoYT.sistem.hareketler',
  'cam.kutuk.durum': 'FikoYT.sistem.hareketler',
  'cam.cnc-islem': 'FikoYT.sistem.hareketler',
  'cam.cnc.durum': 'FikoYT.sistem.hareketler',
  'cam.andon': 'FikoYT.sistem.hareketler',
  'cam.bakim': 'FikoYT.sistem.hareketler',
  'cam.kalite': 'FikoYT.sistem.hareketler',
  'cam.vardiya': 'FikoYT.sistem.hareketler',
  'cam.enerji': 'FikoYT.sistem.hareketler',
  'kutuk-stok': 'FikoYT.sistem.hareketler',
  'kutuk-stok.hareket': 'FikoYT.sistem.hareketler',
  'genel-stok': 'FikoYT.sistem.hareketler',
  'genel-stok.hareket': 'FikoYT.sistem.hareketler',
};
